import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./link-list.scss";

const LinkList = ({ heading, className, children, ...props }) => {
  const classes = classNames("link-list", className);
  return (
    <div className={classes} {...props}>
      {heading && <h3 className="h600 u-margin-bottom-1">{heading}</h3>}
      <ul>{children}</ul>
    </div>
  );
};

LinkList.propTypes = {
  heading: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default LinkList;
